import React, { Fragment, useEffect, useRef, useState, useMemo } from "react";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Row,
  Label,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import apiResponse from "../../../../services/apiResponse";
import IndexBloc from "./Blocs/IndexBlock";
import TableActiveComponent from "./Components/TableActiveComponent";
import EmployeeTableComponent from "./Components/EmployeeTableComponent";
import DatePicker from "../../../../helpers/ui/DatePicker";
import { AvForm, AvField } from "availity-reactstrap-validation";
import moment from "moment";
import { accessRole } from "../../../../helpers/access_role";
import { Link } from "react-router-dom";
import Shimmer from "react-shimmer-effect";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

const IndexView = (props) => {
  let indexBloc = useMemo(() => new IndexBloc(), []);

  const [activeTab, setactiveTab] = useState("1");
  const [modalShowPopupExport, setModalShowPopupExport] = useState(false);
  const [modalShowEmployee, setModalShowEmployee] = useState(false);
  const [modalShowPopupExportWarning, setModalShowPopupExportWarning] =
    useState(false);
  const [type, setType] = useState(false);

  const activeRef = useRef();
  const inactiveRef = useRef();

  const [fileUrl, setFileUrl] = useState("");

  const [modal, setModal] = useState(false);

  // Select
  const [optionEmpCategories, setOptionEmpCategories] = useState([]);
  const [optionUnits, setOptionUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedEmpCategories, setSelectedEmpCategories] = useState({
    label: "INTERNAL",
    value: "f3dd847a-ed83-4539-9a16-7df9048cd42b",
  });
  const [selEmpCategory, setselEmpCategory] = useState("");
  const [selUnit, setselUnit] = useState("");

  const [warning, setWarning] = useState([]);
  const [IsLoadingWarning, setIsLoadingWarning] = useState(false);

  //export validation
  const [presensiStartDate, setPresensiStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [presensiEndDate, setPresensiEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  useEffect(() => {
    // get data unit
    indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            setOptionUnits(
              reformatOptions(response, "work_unit_name_tabs", "work_unit_uuid")
            );
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.employeeCategoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            setOptionEmpCategories(
              reformatOptions(
                response,
                "employee_categories_name_full",
                "employee_categories_uuid"
              )
            );
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.warningChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          setIsLoadingWarning(true);
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setWarning(response);
            setIsLoadingWarning(false);
          }
          break;
        case apiResponse.ERROR:
          setIsLoadingWarning(false);
          break;
        default:
          break;
      }
    });

    // indexBloc.exportExcelChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         let response = result.data.response;
    //         setFileUrl(response.file_url);
    //         //setModal(!modal)
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    indexBloc.warningExportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setFileUrl(response.file_url);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.fetchWorkUnit({});
    indexBloc.fetchEmployeeCategories({});
    // indexBloc.fetchWarningAbsen({});

    return () => {
      indexBloc.workUnitChannel?.unsubscribe();
      indexBloc.employeeCategoriesChannel?.unsubscribe();
      indexBloc.warningChannel?.unsubscribe();
    };
  }, []);

  let additionalFilter = {
    emp_categories: selectedEmpCategories.value || "",
    work_unit: selectedUnit.value || "",
    presensi_start_date: presensiStartDate,
    presensi_end_date: presensiEndDate,
  };

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const exportActiveRef = () => activeRef.current.exportExcel();
  const exportketidakhadiranActiveRef = () =>
    activeRef.current.exportKetidakhadiranExcel();

  const reloadInactiveRef = () => inactiveRef.current.setTokenAPI();

  function handleButtonSearch() {
    reloadActiveRef();
  }

  function handleButtonKetidakhadiranExport() {
    exportketidakhadiranActiveRef();
  }

  function handleButtonExport() {
    exportActiveRef();
  }

  function handleButtonReset() {
    setSelectedUnit("");
    setSelectedEmpCategories("");
    setTimeout(() => {
      reloadActiveRef();
    }, 300);
  }

  function togglePopupExport(status) {
    if (status === "open") {
      setModalShowPopupExport(true);
    }
    if (status === "close") {
      setModalShowPopupExport(false);
    }
  }

  const togglePopupEmployeeTable = () => setModalShowEmployee((prev) => !prev);

  function handlerOnExportSubmit() {
    togglePopupExport("close");
    handleButtonExport();
  }

  function handleButtonExportWarning() {
    setModalShowPopupExportWarning(!modalShowPopupExportWarning);

    indexBloc.fetchexportWarningList({
      // ...additionalFilter,
    });
  }

  return (
    <Fragment>
      <Container fluid>
        {/* <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <div className="float-end">
                  <Button
                    color="success"
                    type="button"
                    onClick={() => {
                      handleButtonExportWarning();
                    }}
                  >
                    Export Warning
                  </Button>
                </div>
                <CardTitle>Warning Absen</CardTitle>
                <hr />

                <Row className="mb-3">
                  {IsLoadingWarning === true ? (
                    <>
                      <Col md="12">
                        <Shimmer>
                          <div
                            style={{
                              width: "100%",
                              height: 55,
                            }}
                          ></div>
                        </Shimmer>
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col md="2" className="border-end border-2">
                        <div
                          className="social-source text-center mt-3 cursor-pointer"
                          onClick={() => {
                            setType(1);
                            togglePopupEmployeeTable();
                          }}
                        >
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-primary font-size-16">
                              <i className="mdi mdi-account-multiple-check text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">Jumlah Pegawai</h5>
                          <p className="text-muted mb-0">
                            {warning ? warning.total_emp : "-"}
                          </p>
                        </div>
                      </Col>
                      <Col md="1" className="border-end border-2">
                        <div className="social-source text-center mt-3">
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-success font-size-16">
                              <i className="mdi mdi-beach text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">Cuti</h5>
                          <p
                            className="text-muted mb-0"
                            onClick={() => {
                              setType(2);
                              togglePopupEmployeeTable();
                            }}
                          >
                            {warning ? warning.total_cuti : "-"}
                          </p>
                        </div>
                      </Col>
                      <Col md="2" className="border-end border-2">
                        <div className="social-source text-center mt-3">
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-primary font-size-16">
                              <i className="mdi mdi-file-check text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">Surat Tugas</h5>
                          <p
                            className="text-muted mb-0"
                            onClick={() => {
                              setType(3);
                              togglePopupEmployeeTable();
                            }}
                          >
                            {warning ? warning.total_st : "-"}
                          </p>
                        </div>
                      </Col>
                      <Col md="2" className="border-end border-2">
                        <div className="social-source text-center mt-3">
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-purple font-size-16">
                              <i className="mdi mdi-book-open-page-variant text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">Tugas Belajar</h5>
                          <p
                            className="text-muted mb-0"
                            onClick={() => {
                              setType(4);
                              togglePopupEmployeeTable();
                            }}
                          >
                            {warning ? warning.total_tubel : "-"}
                          </p>
                        </div>
                      </Col>
                      <Col md="2" className="border-end border-2">
                        <div className="social-source text-center mt-3">
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-primary font-size-16">
                              <i className="mdi mdi-account-remove text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">
                            Jumlah Pegawai yang harus absen
                          </h5>
                          <p
                            className="text-muted mb-0"
                            onClick={() => {
                              setType(5);
                              togglePopupEmployeeTable();
                            }}
                          >
                            {warning ? warning.total_should_present : "-"}
                          </p>
                        </div>
                      </Col>
                      <Col md="1" className="border-end border-2">
                        <div className="social-source text-center mt-3">
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-success font-size-16">
                              <i className="mdi mdi-calendar-check-outline text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">Absen</h5>
                          <p
                            className="text-muted mb-0"
                            onClick={() => {
                              setType(6);
                              togglePopupEmployeeTable();
                            }}
                          >
                            {warning ? warning.total_present : "-"}
                          </p>
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="social-source text-center mt-3">
                          <div className="avatar-xs mx-auto mb-3">
                            <span className="avatar-title rounded-circle bg-danger font-size-16">
                              <i className="mdi mdi-calendar-remove-outline text-white"></i>
                            </span>
                          </div>
                          <h5 className="font-size-15">Tidak Absen</h5>
                          <p
                            className="text-muted mb-0"
                            onClick={() => {
                              setType(7);
                              togglePopupEmployeeTable();
                            }}
                          >
                            {warning ? warning.total_not_present : "-"}
                          </p>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                {/* <div className="float-end">
                                {
                                    (accessRole('read')) ?
                                        <Link to="/kepegawaian/presensi.html?simulation">
                                            <Button color="primary">Simulasi</Button>
                                        </Link>
                                    : null
                                }
                                </div> */}
                <CardTitle>List Data Pegawai</CardTitle>
                <CardSubtitle className="mb-3">
                  Daftar Seluruh Pegawai
                </CardSubtitle>
                <hr />

                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Kategori Pegawai
                  </label>
                  <Col md="4">
                    <Select
                      value={optionEmpCategories.filter(
                        (option) => option.value === selectedEmpCategories.value
                      )}
                      onChange={(selectedOption) => {
                        // Fungsi ini akan dijalankan saat nilai pilihan berubah
                        setSelectedEmpCategories(selectedOption);
                        setselEmpCategory(selectedOption.value);
                        // console.log("Nilai pilihan berubah:", selEmpCategory);
                      }}
                      required="required"
                      options={optionEmpCategories}
                      classNamePrefix="select2-unit"
                    />
                    {/* <Select
                                            value={optionEmpCategories.filter(option =>
                                                option.value === selectedEmpCategories.value)}
                                            onChange={(v) => setSelectedEmpCategories(v)
                                            }
                                            required="required"
                                            options={optionEmpCategories}
                                            classNamePrefix="select2-unit"
                                        /> */}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Unit Kerja
                  </label>
                  <Col md="4">
                    <Select
                      value={optionUnits.filter(
                        (option) => option.value === selectedUnit.value
                      )}
                      onChange={(selectedOption) => {
                        // Fungsi ini akan dijalankan saat nilai pilihan berubah
                        // console.log("Nilai unit kerja pilihan berubah:", selectedOption.value);
                        setSelectedUnit(selectedOption);
                        setselUnit(selectedOption.value);
                      }}
                      required="required"
                      options={optionUnits}
                      classNamePrefix="select2-unit"
                    />
                    {/* <Select
                                            value={optionUnits.filter(option =>
                                                option.value === selectedUnit.value)}
                                            onChange={(s) => setSelectedUnit(s)}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        /> */}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="2"></Col>
                  <Col md="10">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => {
                        handleButtonSearch();
                      }}
                    >
                      <i className="uil-search-alt"></i> Cari
                    </Button>{" "}
                    <Button
                      color="warning"
                      type="button"
                      onClick={() => {
                        handleButtonReset();
                      }}
                    >
                      <i className="uil-excel"></i> Reset
                    </Button>{" "}
                    <Button
                      color="success"
                      type="button"
                      onClick={() => {
                        togglePopupExport("open");
                      }}
                    >
                      Export Kehadiran
                    </Button>
                    {/* {' '}
                                        <Button 
                                          color="success" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonKetidakhadiranExport()
                                          }}
                                        >
                                            Export Daftar Ketidakhadiran
                                        </Button> */}{" "}
                    {accessRole("approve") &&
                    selEmpCategory == "5c2e9672-248b-461d-b75d-c479aa39276c" ? (
                      <Link to="?uploadpresensi">
                        <Button color="primary">Upload PTSP</Button>
                      </Link>
                    ) : null}
                  </Col>
                </Row>

                <hr />

                <TableActiveComponent
                  ref={activeRef}
                  handleInactiveSuccess={reloadInactiveRef}
                  additionalFilter={additionalFilter}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal size="md" isOpen={modalShowPopupExport} toggle={() => {}}>
        <AvForm
          className="needs-validation"
          onValidSubmit={() => handlerOnExportSubmit()}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              Export Kehadiran
            </h5>
          </div>
          <div className="modal-body">
            <Row className="mb-3">
              <label className="col-md-6 col-form-label">
                Periode Mulai <span className="text-danger">*</span>
              </label>
              <Col md="6">
                <AvField
                  name="presensi_start_period"
                  placeholder="Periode Mulai..."
                  type="date"
                  errorMessage="Masukkan Periode Mulai"
                  className="form-control"
                  onChange={(event) => setPresensiStartDate(event.target.value)}
                  id="presensi_start_period"
                  value={presensiStartDate}
                />
              </Col>
            </Row>
            <Row>
              <label className="col-md-6 col-form-label">
                Periode Akhir <span className="text-danger">*</span>
              </label>
              <Col md="6">
                <AvField
                  name="presensi_end_period"
                  placeholder="Periode Akhir..."
                  type="date"
                  errorMessage="Masukkan Periode Akhir"
                  className="form-control"
                  onChange={(event) => setPresensiEndDate(event.target.value)}
                  id="presensi_end_period"
                  value={presensiEndDate}
                  min={presensiStartDate}
                  validate={{
                    min: { value: presensiStartDate, errorMessage: 'Periode akhir tidak boleh kurang dari periode mulai' }
                  }}
                />
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => {
                togglePopupExport("close");
              }}
              className="btn btn-danger waves-effect"
              data-dismiss="modal"
            >
              Batal
            </button>
            <button
              type="submit"
              className="btn btn-primary waves-effect waves-light"
            >
              Export
            </button>
          </div>
        </AvForm>
      </Modal>

      {/* Modal Export Warning Absen  */}

      <Modal
        isOpen={modalShowPopupExportWarning}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setModalShowPopupExportWarning(!modalShowPopupExportWarning);
        }}
      >
        <div className="modal-content">
          <ModalHeader
            toggle={() => {
              setModalShowPopupExportWarning(!modalShowPopupExportWarning);
              setFileUrl("");
            }}
          >
            Export
          </ModalHeader>
          <ModalBody>
            {fileUrl == "" ? (
              <div className="text-center">
                <Spinner className="m-1" color="primary" />
                <div>Memproses Data</div>
              </div>
            ) : (
              <>
                <Row className="mb-3">
                  <label className="col-md-4">Jenis File</label>
                  <Col md="8">Excel (xlsx)</Col>
                </Row>
                <Row className="mb-3">
                  <label className="col-md-4">Waktu Generate</label>
                  <Col md="8">
                    {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <label className="col-md-4">Link</label>
                  <Col md="8">
                    <a
                      target={"_blank"}
                      className="btn btn-success"
                      href={fileUrl}
                    >
                      Download <i className="fa fa-download ms-1"></i>
                    </a>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setModalShowPopupExportWarning(!modalShowPopupExportWarning);
                setFileUrl("");
              }}
            >
              Kembali
            </Button>
          </ModalFooter>
        </div>
      </Modal>

      <EmployeeTableComponent
        type={type}
        modal={modalShowEmployee}
        toggle={() => setModalShowEmployee((prev) => !prev)}
      />
    </Fragment>
  );
};

export default IndexView;
